<template>
  <div id="student-basic">
    <h4 class="sub-title">Basic Information</h4>
    <div class="first-name mt-4">
      <label for="first-name">First Name:</label>
      <b-form-input
        name="name"
        type="text"
        id="first-name"
        v-model="first_name"
        :state="firstInput"
        required
      ></b-form-input>
    </div>
    <div class="middle-name mt-4">
      <label for="middle-name">Middle Name:</label>
      <b-form-input
        name="name"
        type="text"
        id="middle-name"
        v-model="middle_name"
      ></b-form-input>
    </div>
    <div class="last-name mt-4">
      <label for="last-name">Last Name:</label>
      <b-form-input
        name="name"
        type="text"
        id="last-name"
        v-model="last_name"
        :state="lastInput"
        required
      ></b-form-input>
    </div>
    <div class="dob mt-4">
      <label for="dob">Date of Birth:</label>
      <b-form-input
        name="dob"
        type="date"
        id="dob"
        v-model="dob"
        required
      ></b-form-input>
    </div>
    <div class="sex mt-4">
      <label for="sex">Sex:</label>
      <b-form-select
        name="sex"
        type="text"
        id="sex"
        v-model="sex"
        :state="sInput"
      >
        <option disabled value>Select a Sex</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
      </b-form-select>
    </div>
    <div class="main-languages mt-4">
      <label for="name">Languages Spoken:</label>
      <b-form-select name="main-languages" v-model="languages[0]">
        <option value disabled>Select a language</option>
        <option v-for="(lang, i) in langs" :key="i" :value="lang">
          {{ lang }}
        </option>
      </b-form-select>
      <b-form-select name="main-languages" v-model="languages[1]">
        <option value disabled>Select a language</option>
        <option v-for="(lang, i) in langs" :key="i" :value="lang">
          {{ lang }}
        </option>
      </b-form-select>
      <b-form-select name="main-languages" v-model="languages[2]">
        <option value disabled>Select a language</option>
        <option v-for="(lang, i) in langs" :key="i" :value="lang">
          {{ lang }}
        </option>
      </b-form-select>
    </div>
    <div class="emisId mt-4">
      <label for="emis-id">EMIS / Other ID Number for Tracking:</label>
      <b-form-input
        name="emis-id"
        type="text"
        id="emis-id"
        v-model="emis_id"
      ></b-form-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentBasic',
  props: {
    plural: String,
    singular: String,
  },
  data() {
    return {
      langs: [
        'Chitumbuka',
        'Chichewa',
        'Chiyao',
        'Kavango',
        'Lozi',
        'Oshiwambo',
        'Otjiherero',
        'Nama/Damara/Khoekhoegowab',
        'San',
        'Afrikaans',
        'English',
        'German',
        'Portuguese',
        'Lozi',
        'Bemba',
        'Lunda',
        'Tonga',
        'Luvale',
        'Kaonde',
        'Nyanja',
      ],
    };
  },
  computed: {
    first_name: {
      get() {
        return this.$store.state.students.student.first_name;
      },
      set(val) {
        this.$store.commit('students/first_name', val);
      },
    },
    middle_name: {
      get() {
        return this.$store.state.students.student.middle_name;
      },
      set(val) {
        this.$store.commit('students/middle_name', val);
      },
    },
    last_name: {
      get() {
        return this.$store.state.students.student.last_name;
      },
      set(val) {
        this.$store.commit('students/last_name', val);
      },
    },
    dob: {
      get() {
        return this.$store.state.students.student.dob;
      },
      set(val) {
        this.$store.commit('students/dob', val);
      },
    },
    sex: {
      get() {
        return this.$store.state.students.student.sex;
      },
      set(val) {
        this.$store.commit('students/sex', val);
      },
    },
    emis_id: {
      get() {
        return this.$store.state.students.student.emis_id;
      },
      set(val) {
        this.$store.commit('students/emis_id', val);
      },
    },
    languages: {
      get() {
        return this.$store.state.students.student.languages;
      },
      set(val) {
        this.$store.commit('students/languages', val);
      },
    },
    firstInput() {
      return (
        this.$store.state[this.plural][this.singular].first_name.length > 2
      );
    },
    lastInput() {
      return this.$store.state[this.plural][this.singular].last_name.length > 2;
    },
    sInput() {
      return this.$store.state[this.plural][this.singular].sex.length > 2;
    },
  },
};
</script>
